import http from "@/api/http";
import moment from 'moment';

const PREFIX = '/school'
const IS_MOCK = process.env.VUE_APP_IS_MOCK == 'true'
const IOT_DEVICE_LOAD_SUBTRACT_MIN = parseInt(process.env.VUE_APP_IOT_DATA_LOAD_SUBTRACT_MIN) //ikkim
const IOT_DASHBOARD_LOAD_SUBTRACT_MIN = (IOT_DEVICE_LOAD_SUBTRACT_MIN+1) //ikkim
const R4470_DEVICE_LOAD_SUBTRACT_MIN = parseInt(process.env.VUE_APP_R4470_DATA_LOAD_SUBTRACT_MIN) //211008

async function getSchool(uuid) {
    let url = `${PREFIX}`
    if (!IS_MOCK) {
        return http.get(url, { uuid });
    } else {
        const mockReponse = { 
            "school": {
                "insertId": null,
                "createDateTime": "2019-11-26T21:55:50Z",
                "updateDateTime": "2019-11-26T21:55:50Z",
                "uuid": "a7c13a52-9e50-434c-b0e9-fa3b009163d5",
                "name": "돌마초등학교",
                "type": 2, //3: bus
                "post": "95000",
                "memo":"test",
                "address1": "경기도 성남시 분당구",
                "address2": " 야탑동 야탑로 96-7",
                "mwgMac": "G00:11:22:33:44:55",
                "mwdsIp": "192.168.111.222",
                "enable": "Y",
            },
            "class": [
                {
                    "insertId": null,
                    "createDateTime": "2019-11-27T03:44:05Z",
                    "updateDateTime": "2019-11-27T03:44:05Z",
                    "classNo": 1,
                    "gradeName": "1",
                    "className": "시립미사호반어린이집",
                    "fullName": "시립미사호반아파트 어린이집 테스트 이름",
                    "enable": "Y",
                    "classType": 0,
                    "connectCount" : 99,
                    "isConnected": "Y",
                    "lat": 37.300635543830715,
                    "lng": 127.07113692087363,
                    "apcInfo": [
                        /*
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:14Z",
                            "updateDateTime": "2019-11-27T04:20:14Z",
                            "apcInfoNo": "1",
                            "position": 0,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:14Z",
                            "updateDateTime": "2019-11-27T04:20:14Z",
                            "apcInfoNo": "1",
                            "position": 0,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:14Z",
                            "updateDateTime": "2019-11-27T04:20:14Z",
                            "apcInfoNo": "1",
                            "position": 0,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        */
                        
                        /*
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:57Z",
                            "updateDateTime": "2019-11-27T04:20:57Z",
                            "apcInfoNo": "2",
                            "position": 1,
                            "power": "N",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:21:43Z",
                            "updateDateTime": "2019-11-27T04:21:43Z",
                            "apcInfoNo": "3",
                            "position": 1,
                            "power": "N",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:22:04Z",
                            "updateDateTime": "2019-11-27T04:22:04Z",
                            "apcInfoNo": "4",
                            "position": 4,
                            "power": "Y",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        }*/
                    ],
                    "mwdDevice": {
                        "insertId": null,
                        "createDateTime": "2019-11-28T21:19:20Z",
                        "updateDateTime": "2019-11-28T21:19:20Z",
                        "mwdMac": "c001122334455",
                        "mwdType": "MWC",
                        "mwdOutMac" : "s001122334456",
                        "installPlace" : "사랑스런보람",
                        "enable": "Y",
                        "pm10": 12,
                        "pm25": 15,
                        "co2": 1001,
                        "voc": 0,//6000,
                        "temp": 10,
                        "humm": 60,

                //for test
                "clockTimeHour": "02",
                "clockTimeMinute": "04",
                "clockTimeHourLevel": 1,
                "clockTimeMinuteLevel": 4

                    },
                    //for test
                    "outDevice": {
                        "insertId": null,
                        "createDateTime": "2019-11-28T21:19:20Z",
                        "updateDateTime": "2019-11-28T21:19:20Z",
                        "mwdMac": "s00112233445a",
                        "mwdType": "MWC",
                        "installPlace" : "사랑스런보람",
                        "enable": "Y",
                        "bat":1111,
                        "pm10": 12,
                        "pm25": 10,
                        "co2": 200,
                        "voc": 100,
                        "temp": 10,
                        "humm": 60
                    },
                    "option": {
                        "memos" : [{"date":"2024/12/24 12:34", "memo":"12345", "creator":"김인기"}]
                    }
                },
                //power controller
                {
                    "insertId": null,
                    "createDateTime": "2019-11-27T03:44:05Z",
                    "updateDateTime": "2019-11-27T03:44:05Z",
                    "classNo": 2,
                    "gradeName": "1",
                    "className": "열린어린이집",
                    "fullName": "어린이 어린이 어린이",
                    "enable": "Y",
                    "classType": 0,
                    "connectCount" : 99,
                    "isConnected": "N",
                    "lat": 37.251395886446154,
                    "lng": 127.43610090575446,
                    "apcInfo": [
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:57Z",
                            "updateDateTime": "2019-11-27T04:20:57Z",
                            "apcInfoNo": "2",
                            "position": 1,
                            "power": "N",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0,
                            "apcRunMode":2,
                            "apcLevel":1
                        },
                        /*
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:21:43Z",
                            "updateDateTime": "2019-11-27T04:21:43Z",
                            "apcInfoNo": "3",
                            "position": 1,
                            "power": "N",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:22:04Z",
                            "updateDateTime": "2019-11-27T04:22:04Z",
                            "apcInfoNo": "4",
                            "position": 4,
                            "power": "Y",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        }*/
                    ],
                    "mwdDevice": {
                        "insertId": null,
                        "createDateTime": "2019-11-28T21:19:20Z",
                        "updateDateTime": "2019-11-28T21:19:20Z",
                        "mwdMac": "w001122334455",
                        "mwdType": "MWI",
                        "installPlace" : "에리꾸힘내욤",
                        "enable": "Y",
                        "bat":12,
                        "pm10": 32,
                        "pm25": 1234567,
                        "co2": 2200,
                        "voc": 10,
                        "temp": 10,
                        "humm": 60
                    }
                },
                {
                    "insertId": null,
                    "createDateTime": "2019-11-27T03:44:05Z",
                    "updateDateTime": "2019-11-27T03:44:05Z",
                    "classNo": 3,
                    "gradeName": "2",
                    "className": "열린어린이집",
                    "fullName": "어린이 어린이",
                    "enable": "Y",
                    "classType": 0,
                    "connectCount" : 99,
                    "isConnected": "Y",
                    "lat": 37.251395886446154,
                    "lng": 127.43610090575446,
                    "apcInfo": [
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:57Z",
                            "updateDateTime": "2019-11-27T04:20:57Z",
                            "apcInfoNo": "2",
                            "position": 1,
                            "power": "N",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0,
                            "apcRunMode":2,
                            "apcLevel":1
                        },
                        /*
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:21:43Z",
                            "updateDateTime": "2019-11-27T04:21:43Z",
                            "apcInfoNo": "3",
                            "position": 1,
                            "power": "N",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:22:04Z",
                            "updateDateTime": "2019-11-27T04:22:04Z",
                            "apcInfoNo": "4",
                            "position": 4,
                            "power": "Y",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        }*/
                    ],
                    "mwdDevice": {
                        "insertId": null,
                        "createDateTime": "2019-11-28T21:19:20Z",
                        "updateDateTime": "2019-11-28T21:19:20Z",
                        "mwdMac": "w001122334455",
                        "mwdType": "MWW",
                        "installPlace" : "에리꾸힘내욤",
                        "enable": "Y",
                        "bat":12,
                        "pm10": 32,
                        "pm25": 1234567,
                        "co2": 2200,
                        "voc": 10,
                        "temp": 10,
                        "humm": 60
                    }
                },
                {
                    "insertId": null,
                    "createDateTime": "2019-11-27T03:44:05Z",
                    "updateDateTime": "2019-11-27T03:44:05Z",
                    "classNo": 4,
                    "gradeName": "1",
                    "className": "3",
                    "fullName": "g743AEF83D4AB",
                    "enable": "Y",
                    "classType": 0,
                    "connectCount" : 99,
                    "isConnected": "N",
                    "apcInfo": [
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:14Z",
                            "updateDateTime": "2019-11-27T04:20:14Z",
                            "apcInfoNo": "1",
                            "position": 0,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:57Z",
                            "updateDateTime": "2019-11-27T04:20:57Z",
                            "apcInfoNo": "2",
                            "position": 1,
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "power": "N",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:57Z",
                            "updateDateTime": "2019-11-27T04:20:57Z",
                            "apcInfoNo": "2",
                            "position": 1,
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "power": "N",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:57Z",
                            "updateDateTime": "2019-11-27T04:20:57Z",
                            "apcInfoNo": "2",
                            "position": 1,
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "power": "N",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:57Z",
                            "updateDateTime": "2019-11-27T04:20:57Z",
                            "apcInfoNo": "2",
                            "position": 1,
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "power": "N",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:57Z",
                            "updateDateTime": "2019-11-27T04:20:57Z",
                            "apcInfoNo": "2",
                            "position": 1,
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "power": "N",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                    ],
                    "mwdDevice": {
                        "insertId": null,
                        "createDateTime": "2019-11-28T21:19:20Z",
                        "updateDateTime": "2019-11-28T21:19:20Z",
                        "mwdMac": "s001122334490",
                        "mwdOutMac": "s00112233445b",
                        "mwdType": "MWS",
                        "enable": "Y",
                        "pm10": 232,
                        "pm25": 70,
                        "co2": 200,
                        "voc": 110,
                        "temp": 10,
                        "humm": 60
                    },
                },
                {
                    "insertId": null,
                    "createDateTime": "2019-11-27T03:44:05Z",
                    "updateDateTime": "2019-11-27T03:44:05Z",
                    "classNo": 5,
                    "gradeName": "1",
                    "className": "4",
                    "fullName": "1-4",
                    "enable": "Y",
                    "classType": 0,
                    "connectCount" : 99,
                    "isConnected": "Y",
                    "apcInfo": [
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:14Z",
                            "updateDateTime": "2019-11-27T04:20:14Z",
                            "apcInfoNo": "1",
                            "position": 0,
                            "power": "Y",
                            "irCode":"8010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        /*
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:57Z",
                            "updateDateTime": "2019-11-27T04:20:57Z",
                            "apcInfoNo": "2",
                            "position": 1,
                            "power": "N",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:21:43Z",
                            "updateDateTime": "2019-11-27T04:21:43Z",
                            "apcInfoNo": "3",
                            "position": 6,
                            "power": "N",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        },*/
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:22:04Z",
                            "updateDateTime": "2019-11-27T04:22:04Z",
                            "apcInfoNo": "4",
                            "position": 8,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        }
                    ],
                    "mwdDevice": {
                        "insertId": null,
                        "createDateTime": "2019-11-28T21:19:20Z",
                        "updateDateTime": "2019-11-28T21:19:20Z",
                        //"mwdMac": "i001122334491",
                        "mwdMac": "ifffffb000001",
                        "mwdOutMac": "s001122334456",
                        "mwdType": "MWI",
                        "enable": "Y",
                        "pm10": 72,
                        "pm25": 70,
                        "co2": 2200,
                        "voc": 10,
                        "temp": 10,
                        "humm": 60
                    },
                    "option": {
                        "memos" : [{"date":"2024/12/24 12:34", "memo":"12345", "creator":"김인기222"}]
                    }
                },
                {
                    "insertId": null,
                    "createDateTime": "2019-11-27T03:44:05Z",
                    "updateDateTime": "2019-11-27T03:44:05Z",
                    "classNo": 6,
                    "gradeName": "1",
                    "className": "6",
                    "fullName": "1-6",
                    "enable": "Y",
                    "classType": 0,
                    "connectCount" : 99,
                    "isConnected": "Y",
                    "apcInfo": [
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:14Z",
                            "updateDateTime": "2019-11-27T04:20:14Z",
                            "apcInfoNo": "1",
                            "position": 0,
                            "power": "Y",
                            "irCode":"2010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0,
                            "apcLevel":1
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:57Z",
                            "updateDateTime": "2019-11-27T04:20:57Z",
                            "apcInfoNo": "2",
                            "position": 3,
                            "power": "N",
                            "irCode":"3010",
                            "irOnCode":"00000000",
                            "irOffCode":"23451113",
                            "apcModelName": "R-1000",
                            "apcBrandName": "릴레이",
                            "apcType": 0,
                            "apcLevel":0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:21:43Z",
                            "updateDateTime": "2019-11-27T04:21:43Z",
                            "apcInfoNo": "3",
                            "position": 4,
                            "power": "N",
                            "irCode":"3010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:22:04Z",
                            "updateDateTime": "2019-11-27T04:22:04Z",
                            "apcInfoNo": "4",
                            "position": 4,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:22:04Z",
                            "updateDateTime": "2019-11-27T04:22:04Z",
                            "apcInfoNo": "5",
                            "position": 4,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:22:04Z",
                            "updateDateTime": "2019-11-27T04:22:04Z",
                            "apcInfoNo": "6",
                            "position": 4,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        }
                    ],
                    "mwdDevice": {
                        "insertId": null,
                        "createDateTime": "2019-11-28T21:19:20Z",
                        "updateDateTime": "2019-11-28T21:19:20Z",
                        "mwdMac": "c001122334492",
                        "mwdType": "MWC",
                        "enable": "Y",
                        "pm10": 32,
                        "pm25": 70,
                        "co2": 2200,
                        "voc": 10,
                        "temp": 10,
                        "humm": 60
                    }
                },
                {
                    "insertId": null,
                    "createDateTime": "2019-11-27T03:44:05Z",
                    "updateDateTime": "2019-11-27T03:44:05Z",
                    "classNo": 7,
                    "gradeName": "1",
                    "className": "7",
                    "fullName": "1-7",
                    "enable": "Y",
                    "classType": 0,
                    "connectCount" : 99,
                    "isConnected": "Y",
                    "apcInfo": [
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:14Z",
                            "updateDateTime": "2019-11-27T04:20:14Z",
                            "apcInfoNo": "1",
                            "position": 0,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:57Z",
                            "updateDateTime": "2019-11-27T04:20:57Z",
                            "apcInfoNo": "2",
                            "position": 1,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:21:43Z",
                            "updateDateTime": "2019-11-27T04:21:43Z",
                            "apcInfoNo": "3",
                            "position": 1,
                            "power": "N",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:22:04Z",
                            "updateDateTime": "2019-11-27T04:22:04Z",
                            "apcInfoNo": "4",
                            "position": 5,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        }
                    ],
                    "mwdDevice": {
                        "insertId": null,
                        "createDateTime": "2019-11-28T21:19:20Z",
                        "updateDateTime": "2019-11-28T21:19:20Z",
                        "mwdMac": "c001122334493",
                        "mwdType": "MWC",
                        "enable": "Y",
                        "pm10": 32,
                        "pm25": 70,
                        "co2": 2200,
                        "voc": 10,
                        "temp": 10,
                        "humm": 60
                    }
                },
                {
                    "insertId": null,
                    "createDateTime": "2019-11-27T03:44:05Z",
                    "updateDateTime": "2019-11-27T03:44:05Z",
                    "classNo": 8,
                    "gradeName": "2",
                    "className": "1",
                    "fullName": "2",
                    "enable": "Y",
                    "classType": 0,
                    "connectCount" : 99,
                    "isConnected": "Y",
                    "apcInfo": [
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:14Z",
                            "updateDateTime": "2019-11-27T04:20:14Z",
                            "apcInfoNo": "1",
                            "position": 0,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:57Z",
                            "updateDateTime": "2019-11-27T04:20:57Z",
                            "apcInfoNo": "2",
                            "position": 1,
                            "power": "N",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:21:43Z",
                            "updateDateTime": "2019-11-27T04:21:43Z",
                            "apcInfoNo": "3",
                            "position": 1,
                            "power": "N",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:22:04Z",
                            "updateDateTime": "2019-11-27T04:22:04Z",
                            "apcInfoNo": "4",
                            "position": 4,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        }
                    ],
                    "mwdDevice": {
                        "insertId": null,
                        "createDateTime": "2019-11-28T21:19:20Z",
                        "updateDateTime": "2019-11-28T21:19:20Z",
                        "mwdMac": "c001122334494",
                        "mwdType": "MWC",
                        "enable": "Y",
                        "pm10": 32,
                        "pm25": 70,
                        "co2": 2200,
                        "voc": 10,
                        "temp": 10,
                        "humm": 60
                    }
                },
                {
                    "insertId": null,
                    "createDateTime": "2019-11-27T03:44:05Z",
                    "updateDateTime": "2019-11-27T03:44:05Z",
                    "classNo": 9,
                    "gradeName": "2",
                    "className": "2",
                    "fullName": "2-2",
                    "enable": "Y",
                    "classType": 0,
                    "connectCount" : 99,
                    "isConnected": "Y",
                    "apcInfo": [
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:14Z",
                            "updateDateTime": "2019-11-27T04:20:14Z",
                            "apcInfoNo": "1",
                            "position": 0,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:57Z",
                            "updateDateTime": "2019-11-27T04:20:57Z",
                            "apcInfoNo": "2",
                            "position": 1,
                            "power": "N",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:21:43Z",
                            "updateDateTime": "2019-11-27T04:21:43Z",
                            "apcInfoNo": "3",
                            "position": 1,
                            "power": "N",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:22:04Z",
                            "updateDateTime": "2019-11-27T04:22:04Z",
                            "apcInfoNo": "4",
                            "position": 4,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        }
                    ],
                    "mwdDevice": {
                        "insertId": null,
                        "createDateTime": "2019-11-28T21:19:20Z",
                        "updateDateTime": "2019-11-28T21:19:20Z",
                        "mwdMac": "i001122334495",
                        "mwdType": "MWI",
                        "enable": "Y",
                        "pm10": 32,
                        "pm25": 70,
                        "co2": 2200,
                        "voc": 10,
                        "temp": 10,
                        "humm": 60
                    }
                },
                {
                    "insertId": null,
                    "createDateTime": "2019-11-27T03:44:05Z",
                    "updateDateTime": "2019-11-27T03:44:05Z",
                    "classNo": 10,
                    "gradeName": "2",
                    "className": "3",
                    "fullName": "2-3",
                    "enable": "Y",
                    "classType": 0,
                    "connectCount" : 99,
                    "isConnected": "Y",
                    "apcInfo": [
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:14Z",
                            "updateDateTime": "2019-11-27T04:20:14Z",
                            "apcInfoNo": "1",
                            "position": 0,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:57Z",
                            "updateDateTime": "2019-11-27T04:20:57Z",
                            "apcInfoNo": "2",
                            "position": 1,
                            "power": "N",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:21:43Z",
                            "updateDateTime": "2019-11-27T04:21:43Z",
                            "apcInfoNo": "3",
                            "position": 1,
                            "power": "N",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:22:04Z",
                            "updateDateTime": "2019-11-27T04:22:04Z",
                            "apcInfoNo": "4",
                            "position": 4,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        }
                    ],
                    "mwdDevice": {
                        "insertId": null,
                        "createDateTime": "2019-11-28T21:19:20Z",
                        "updateDateTime": "2019-11-28T21:19:20Z",
                        "mwdMac": "i001122334496",
                        "mwdType": "MWI",
                        "enable": "Y",
                        "pm10": 32,
                        "pm25": 70,
                        "co2": 2200,
                        "voc": 10,
                        "temp": 10,
                        "humm": 60
                    }
                },
                {
                    "insertId": null,
                    "createDateTime": "2019-11-27T03:44:05Z",
                    "updateDateTime": "2019-11-27T03:44:05Z",
                    "classNo": 11,
                    "gradeName": "2",
                    "className": "4",
                    "fullName": "2-4",
                    "enable": "Y",
                    "classType": 0,
                    "connectCount" : 99,
                    "isConnected": "Y",
                    "apcInfo": [
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:14Z",
                            "updateDateTime": "2019-11-27T04:20:14Z",
                            "apcInfoNo": "1",
                            "position": 3,
                            "power": "N",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:57Z",
                            "updateDateTime": "2019-11-27T04:20:57Z",
                            "apcInfoNo": "2",
                            "position": 3,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:21:43Z",
                            "updateDateTime": "2019-11-27T04:21:43Z",
                            "apcInfoNo": "3",
                            "position": 1,
                            "power": "N",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:22:04Z",
                            "updateDateTime": "2019-11-27T04:22:04Z",
                            "apcInfoNo": "4",
                            "position": 4,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        }
                    ],
                    "mwdDevice": {
                        "insertId": null,
                        "createDateTime": "2019-11-28T21:19:20Z",
                        "updateDateTime": "2019-11-28T21:19:20Z",
                        "mwdMac": "i001122334497",
                        "mwdType": "MWI",
                        "enable": "Y",
                        "pm10": 102,
                        "pm25": 170,
                        "co2": 200,
                        "voc": 120,
                        "temp": 10,
                        "humm": 60
                    }
                },
                {
                    "insertId": null,
                    "createDateTime": "2019-11-27T03:44:05Z",
                    "updateDateTime": "2019-11-27T03:44:05Z",
                    "classNo": 12,
                    "gradeName": "3",
                    "className": "1",
                    "fullName": "3-1",
                    "enable": "Y",
                    "classType": 0,
                    "connectCount" : 99,
                    "isConnected": "Y",
                    "apcInfo": [
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:14Z",
                            "updateDateTime": "2019-11-27T04:20:14Z",
                            "apcInfoNo": "1",
                            "position": 0,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:57Z",
                            "updateDateTime": "2019-11-27T04:20:57Z",
                            "apcInfoNo": "2",
                            "position": 1,
                            "power": "N",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:21:43Z",
                            "updateDateTime": "2019-11-27T04:21:43Z",
                            "apcInfoNo": "3",
                            "position": 1,
                            "power": "N",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:22:04Z",
                            "updateDateTime": "2019-11-27T04:22:04Z",
                            "apcInfoNo": "4",
                            "position": 4,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        }
                    ],
                    "mwdDevice": {
                        "insertId": null,
                        "createDateTime": "2019-11-28T21:19:20Z",
                        "updateDateTime": "2019-11-28T21:19:20Z",
                        "mwdMac": "i001122334498",
                        "mwdType": "MWI",
                        "enable": "Y",
                        "pm10": 32,
                        "pm25": 70,
                        "co2": 2200,
                        "voc": 10,
                        "temp": 10,
                        "humm": 60
                    }
                },
                {
                    "insertId": null,
                    "createDateTime": "2019-11-27T03:44:05Z",
                    "updateDateTime": "2019-11-27T03:44:05Z",
                    "classNo": 13,
                    "gradeName": "3",
                    "className": "2",
                    "fullName": "3-2",
                    "enable": "Y",
                    "classType": 0,
                    "connectCount" : 99,
                    "isConnected": "Y",
                    "apcInfo": [
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:14Z",
                            "updateDateTime": "2019-11-27T04:20:14Z",
                            "apcInfoNo": "1",
                            "position": 0,
                            "power": "N",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:57Z",
                            "updateDateTime": "2019-11-27T04:20:57Z",
                            "apcInfoNo": "2",
                            "position": 1,
                            "power": "N",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:21:43Z",
                            "updateDateTime": "2019-11-27T04:21:43Z",
                            "apcInfoNo": "3",
                            "position": 1,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:22:04Z",
                            "updateDateTime": "2019-11-27T04:22:04Z",
                            "apcInfoNo": "4",
                            "position": 4,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        }
                    ],
                    "mwdDevice": {
                        "insertId": null,
                        "createDateTime": "2019-11-28T21:19:20Z",
                        "updateDateTime": "2019-11-28T21:19:20Z",
                        "mwdMac": "i001122334499",
                        "mwdType": "MWI",
                        "enable": "Y",
                        "pm10": 32,
                        "pm25": 70,
                        "co2": 2200,
                        "voc": 10,
                        "temp": 10,
                        "humm": 60
                    }
                },
                {
                    "insertId": null,
                    "createDateTime": "2019-11-27T03:44:05Z",
                    "updateDateTime": "2019-11-27T03:44:05Z",
                    "classNo": 14,
                    "gradeName": "3",
                    "className": "3",
                    "fullName": "3-3",
                    "enable": "Y",
                    "classType": 0,
                    "connectCount" : 99,
                    "isConnected": "Y",
                    "apcInfo": [
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:14Z",
                            "updateDateTime": "2019-11-27T04:20:14Z",
                            "apcInfoNo": "5",
                            "position": 2,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:57Z",
                            "updateDateTime": "2019-11-27T04:20:57Z",
                            "apcInfoNo": "6",
                            "position": 3,
                            "power": "N",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:21:43Z",
                            "updateDateTime": "2019-11-27T04:21:43Z",
                            "apcInfoNo": "7",
                            "position": 4,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:22:04Z",
                            "updateDateTime": "2019-11-27T04:22:04Z",
                            "apcInfoNo": "8",
                            "position": 4,
                            "power": "N",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        }
                    ],
                    "mwdDevice": {
                        "insertId": null,
                        "createDateTime": "2019-11-28T21:19:20Z",
                        "updateDateTime": "2019-11-28T21:19:20Z",
                        "mwdMac": "G22:22:22:22:22:22",
                        "mwdType": "MWI",
                        "enable": "N",
                        "pm10": 12,
                        "pm25": 30,
                        "co2": 900,
                        "voc": 300,
                        "temp": 15,
                        "humm": 39
                    }
                },
                {
                    "insertId": null,
                    "createDateTime": "2019-11-27T03:44:05Z",
                    "updateDateTime": "2019-11-27T03:44:05Z",
                    "classNo": 15,
                    "gradeName": "3",
                    "className": "3",
                    "fullName": "3-3",
                    "enable": "Y",
                    "classType": 0,
                    "connectCount" : 99,
                    "isConnected": "Y",
                    "apcInfo": [
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:14Z",
                            "updateDateTime": "2019-11-27T04:20:14Z",
                            "apcInfoNo": "5",
                            "position": 2,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:57Z",
                            "updateDateTime": "2019-11-27T04:20:57Z",
                            "apcInfoNo": "6",
                            "position": 3,
                            "power": "N",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:21:43Z",
                            "updateDateTime": "2019-11-27T04:21:43Z",
                            "apcInfoNo": "7",
                            "position": 4,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:22:04Z",
                            "updateDateTime": "2019-11-27T04:22:04Z",
                            "apcInfoNo": "8",
                            "position": 4,
                            "power": "N",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        }
                    ],
                    "mwdDevice": {
                        "insertId": null,
                        "createDateTime": "2019-11-28T21:19:20Z",
                        "updateDateTime": "2019-11-28T21:19:20Z",
                        "mwdMac": "G22:22:22:22:22:22",
                        "mwdType": "MWI",
                        "enable": "N",
                        "pm10": 12,
                        "pm25": 30,
                        "co2": 900,
                        "voc": 300,
                        "temp": 15,
                        "humm": 39
                    }
                },
                {
                    "insertId": null,
                    "createDateTime": "2019-11-27T03:44:05Z",
                    "updateDateTime": "2019-11-27T03:44:05Z",
                    "classNo": 16,
                    "gradeName": "3",
                    "className": "3",
                    "fullName": "3-3",
                    "enable": "Y",
                    "classType": 0,
                    "connectCount" : 99,
                    "isConnected": "Y",
                    "apcInfo": [
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:14Z",
                            "updateDateTime": "2019-11-27T04:20:14Z",
                            "apcInfoNo": "5",
                            "position": 2,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:57Z",
                            "updateDateTime": "2019-11-27T04:20:57Z",
                            "apcInfoNo": "6",
                            "position": 3,
                            "power": "N",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:21:43Z",
                            "updateDateTime": "2019-11-27T04:21:43Z",
                            "apcInfoNo": "7",
                            "position": 4,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:22:04Z",
                            "updateDateTime": "2019-11-27T04:22:04Z",
                            "apcInfoNo": "8",
                            "position": 4,
                            "power": "N",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        }
                    ],
                    "mwdDevice": {
                        "insertId": null,
                        "createDateTime": "2019-11-28T21:19:20Z",
                        "updateDateTime": "2019-11-28T21:19:20Z",
                        "mwdMac": "G22:22:22:22:22:22",
                        "mwdType": "MWI",
                        "enable": "N",
                        "pm10": 12,
                        "pm25": 30,
                        "co2": 900,
                        "voc": 300,
                        "temp": 15,
                        "humm": 39
                    }
                },
                {
                    "insertId": null,
                    "createDateTime": "2019-11-27T03:44:05Z",
                    "updateDateTime": "2019-11-27T03:44:05Z",
                    "classNo": 17,
                    "gradeName": "3",
                    "className": "3",
                    "fullName": "3-3",
                    "enable": "Y",
                    "classType": 0,
                    "connectCount" : 99,
                    "isConnected": "Y",
                    "apcInfo": [
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:14Z",
                            "updateDateTime": "2019-11-27T04:20:14Z",
                            "apcInfoNo": "5",
                            "position": 2,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:57Z",
                            "updateDateTime": "2019-11-27T04:20:57Z",
                            "apcInfoNo": "6",
                            "position": 3,
                            "power": "N",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:21:43Z",
                            "updateDateTime": "2019-11-27T04:21:43Z",
                            "apcInfoNo": "7",
                            "position": 4,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:22:04Z",
                            "updateDateTime": "2019-11-27T04:22:04Z",
                            "apcInfoNo": "8",
                            "position": 4,
                            "power": "N",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        }
                    ],
                    "mwdDevice": {
                        "insertId": null,
                        "createDateTime": "2019-11-28T21:19:20Z",
                        "updateDateTime": "2019-11-28T21:19:20Z",
                        "mwdMac": "G22:22:22:22:22:22",
                        "mwdType": "MWI",
                        "enable": "N",
                        "pm10": 12,
                        "pm25": 30,
                        "co2": 900,
                        "voc": 300,
                        "temp": 15,
                        "humm": 39
                    }
                },
                {
                    "insertId": null,
                    "createDateTime": "2019-11-27T03:44:05Z",
                    "updateDateTime": "2019-11-27T03:44:05Z",
                    "classNo": 18,
                    "gradeName": "3",
                    "className": "3",
                    "fullName": "3-3",
                    "enable": "Y",
                    "classType": 0,
                    "connectCount" : 99,
                    "isConnected": "Y",
                    "apcInfo": [
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:14Z",
                            "updateDateTime": "2019-11-27T04:20:14Z",
                            "apcInfoNo": "5",
                            "position": 2,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:57Z",
                            "updateDateTime": "2019-11-27T04:20:57Z",
                            "apcInfoNo": "6",
                            "position": 3,
                            "power": "N",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:21:43Z",
                            "updateDateTime": "2019-11-27T04:21:43Z",
                            "apcInfoNo": "7",
                            "position": 4,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:22:04Z",
                            "updateDateTime": "2019-11-27T04:22:04Z",
                            "apcInfoNo": "8",
                            "position": 4,
                            "power": "N",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        }
                    ],
                    "mwdDevice": {
                        "insertId": null,
                        "createDateTime": "2019-11-28T21:19:20Z",
                        "updateDateTime": "2019-11-28T21:19:20Z",
                        "mwdMac": "G22:22:22:22:22:22",
                        "mwdType": "MWI",
                        "enable": "N",
                        "pm10": 12,
                        "pm25": 30,
                        "co2": 900,
                        "voc": 300,
                        "temp": 15,
                        "humm": 39
                    }
                },
                {
                    "insertId": null,
                    "createDateTime": "2019-11-27T03:44:05Z",
                    "updateDateTime": "2019-11-27T03:44:05Z",
                    "classNo": 19,
                    "gradeName": "3",
                    "className": "3",
                    "fullName": "3-3",
                    "enable": "Y",
                    "classType": 0,
                    "connectCount" : 99,
                    "isConnected": "Y",
                    "apcInfo": [
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:14Z",
                            "updateDateTime": "2019-11-27T04:20:14Z",
                            "apcInfoNo": "5",
                            "position": 2,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:57Z",
                            "updateDateTime": "2019-11-27T04:20:57Z",
                            "apcInfoNo": "6",
                            "position": 3,
                            "power": "N",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:21:43Z",
                            "updateDateTime": "2019-11-27T04:21:43Z",
                            "apcInfoNo": "7",
                            "position": 4,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:22:04Z",
                            "updateDateTime": "2019-11-27T04:22:04Z",
                            "apcInfoNo": "8",
                            "position": 4,
                            "power": "N",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        }
                    ],
                    "mwdDevice": {
                        "insertId": null,
                        "createDateTime": "2019-11-28T21:19:20Z",
                        "updateDateTime": "2019-11-28T21:19:20Z",
                        "mwdMac": "G22:22:22:22:22:22",
                        "mwdType": "MWI",
                        "enable": "N",
                        "pm10": 12,
                        "pm25": 30,
                        "co2": 900,
                        "voc": 300,
                        "temp": 15,
                        "humm": 39
                    }
                },
                {
                    "insertId": null,
                    "createDateTime": "2019-11-27T03:44:05Z",
                    "updateDateTime": "2019-11-27T03:44:05Z",
                    "classNo": 20,
                    "gradeName": "10",
                    "className": "어린이집",
                    "fullName": "10-1",
                    "enable": "Y",
                    "classType": 0,
                    "connectCount" : 99,
                    "isConnected": "Y",
                    "apcInfo": [
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:14Z",
                            "updateDateTime": "2019-11-27T04:20:14Z",
                            "apcInfoNo": "5",
                            "position": 2,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:20:57Z",
                            "updateDateTime": "2019-11-27T04:20:57Z",
                            "apcInfoNo": "6",
                            "position": 3,
                            "power": "N",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "퓨리케어",
                            "apcBrandName": "LG전자",
                            "apcType": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:21:43Z",
                            "updateDateTime": "2019-11-27T04:21:43Z",
                            "apcInfoNo": "7",
                            "position": 4,
                            "power": "Y",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        },
                        {
                            "insertId": null,
                            "createDateTime": "2019-11-27T04:22:04Z",
                            "updateDateTime": "2019-11-27T04:22:04Z",
                            "apcInfoNo": "8",
                            "position": 4,
                            "power": "N",
                            "irCode":"A010",
                            "irOnCode":"0000",
                            "irOffCode":"0000",
                            "apcModelName": "에어 서큘레이터",
                            "apcBrandName": "다이슨",
                            "apcType": 1
                        }
                    ],
                    "mwdDevice": {
                        "insertId": null,
                        "createDateTime": "2019-11-28T21:19:20Z",
                        "updateDateTime": "2019-11-28T21:19:20Z",
                        "mwdMac": "G22:22:22:22:22:22",
                        "mwdType": "MWI",
                        "enable": "N",
                        "pm10": 12,
                        "pm25": 30,
                        "co2": 900,
                        "voc": 300,
                        "temp": 15,
                        "humm": 39
                    }
                },
                {
                    "insertId": null,
                    "createDateTime": "2019-11-27T03:44:05Z",
                    "updateDateTime": "2019-11-27T03:44:05Z",
                    "classNo": 21,
                    "gradeName": "기타",
                    "className": "어린이집2",
                    "fullName": "운동장2",
                    "enable": "Y",
                    "classType": 1,
                    "isConnected": "N", //for test
                    "apcInfo": [
                    ],
                    "mwdDevice": {
                        "insertId": null,
                        "createDateTime": "2019-11-28T21:19:20Z",
                        "updateDateTime": "2019-11-28T21:19:20Z",
                        "mwdMac": "s00112233445a",
                        "mwdType": "MWS",
                        "enable": "Y",
                        "pm10": 100,
                        "pm25": 30,
                        "co2": 300,
                        "voc": 500,
                        "temp": 25,
                        "humm": 20
                    }
                },
                {
                    "insertId": null,
                    "createDateTime": "2019-11-27T03:44:05Z",
                    "updateDateTime": "2019-11-27T03:44:05Z",
                    "classNo": 22,
                    "gradeName": "기타",
                    "className": "어린이집2",
                    "fullName": "운동장",
                    "enable": "Y",
                    "classType": 1,
                    "isConnected": "Y", //for test
                    "apcInfo": [
                    ],
                    "mwdDevice": {
                        "insertId": null,
                        "createDateTime": "2019-11-28T21:19:20Z",
                        "updateDateTime": "2019-11-28T21:19:20Z",
                        "mwdMac": "s001122334456",
                        "mwdType": "MWS",
                        "enable": "Y",
                        "pm10": 10,
                        "pm25": 16,
                        "co2": 0,
                        "voc": 0,
                        "temp": 0,//25,
                        "humm": 0,//20
                    }
                }
            ]
        }

        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        })
    }
}

async function getSchoolInfoByNo(schoolNo) {
    let url = `${PREFIX}/${schoolNo}`
    if (!IS_MOCK) {
        return http.get(url);
    } else {
        const mockReponse = {
            "school":{"insertId":null,"createDateTime":"2023-09-27T09:38:22Z","updateDateTime":"2024-10-23T11:53:57Z","schoolNo":106,"uuid":"2bd96083-4085-4a1d-b40a-86d6e5057836","name":"[양평군청]","type":3,"post":"12554","address1":"경기 양평군 양평읍 군청앞길 2","address2":"양평군청","enable":"Y","installationNum":null,"telNo":"000-000-0000","bizNo":null,"logoFileNm":null,"coverFileNm":null,"coverOpacity":0,"memo":null,"option":"{\"apGoodLevel\":0,\"apNormalLevel\":1,\"apBadLevel\":2,\"apVBadLevel\":3,\"acGoodLevel\":0,\"acNormalLevel\":1,\"acBadLevel\":2,\"acVBadLevel\":3,\"showVent\":\"N\",\"airKoreaDetail\":\"N\"}","gatewayMac":"gb97142001353","optVersion":0,"controlData":null},
            /*
            "class":[
                {"insertId":null,"createDateTime":"2023-09-27T09:38:22Z","updateDateTime":"2025-03-17T02:27:59Z","classNo":1094,"gradeName":"1","className":"실내","fullName":"양평시장입구 45034","enable":"Y","classType":0,"apcInfo":null,"mwdDevice":null,"schoolUuid":"2bd96083-4085-4a1d-b40a-86d6e5057836","connectCount":0,"isConnected":"N","option":"{\"arsNo\":\"45034\",\"gatewayMac\":\"g9877e776b032\",\"memos\":[{\"date\":\"2025/03/13 09:42\",\"memo\":\"전선 매립공사 진행 중 ㅡ 인터넷 공사 준공 후 연결 가능 ㅡ KT확인 결과 공유기 시리얼과 설치 장소와 주소가 일치하지 않음 ㅡ 이 유리 감독님과 내용 공유\",\"creator\":\"이노디지털\",\"showAll\":true,\"id\":\"innodigital\"}]}","gatewayMac":null,"address":"경기도 양평군 양평읍 양근리","lat":"37.489943801757214","lng":"127.49368714229547"},
                {"insertId":null,"createDateTime":"2024-06-07T08:58:25Z","updateDateTime":"2025-05-07T07:04:44Z","classNo":1263,"gradeName":"1","className":"실내","fullName":"아신역 46691","enable":"Y","classType":0,"apcInfo":null,"mwdDevice":null,"schoolUuid":"2bd96083-4085-4a1d-b40a-86d6e5057836","connectCount":0,"isConnected":"N","option":"{\"arsNo\":\"100012\",\"gatewayMac\":\"g9877e776b074\",\"memos\":[{\"date\":\"2025/05/07 16:03\",\"memo\":\"원전원 공급지역의 문제로 전원이 공급안됨, 전기업체가 원전원공급지역을 점검하여 전원공급되어 복구됨\",\"creator\":\"admin\",\"showAll\":true,\"id\":\"misewatch\"},{\"date\":\"2025/01/06 07:54\",\"memo\":\"인터넷 복구됨\",\"creator\":\"이노\",\"id\":\"misewatch\",\"showAll\":true},{\"date\":\"2024/12/27 14:34\",\"memo\":\"인터넷 연결이 끊김(원인파악필요)\",\"creator\":\"이노\",\"id\":\"misewatch\",\"showAll\":true}]}","gatewayMac":null,"address":"경기도 양평군 옥천면 아신리","lat":"37.51354313741988","lng":"127.44314424106165"},
                {"insertId":null,"createDateTime":"2024-01-05T12:09:44Z","updateDateTime":"2025-02-05T10:41:39Z","classNo":1162,"gradeName":"2","className":"비알티","fullName":"▶양평역 46711","enable":"Y","classType":0,"apcInfo":null,"mwdDevice":null,"schoolUuid":"2bd96083-4085-4a1d-b40a-86d6e5057836","connectCount":0,"isConnected":"N","option":"{\"arsNo\":\"46711\",\"gatewayMac\":\"g9877e776afed\"}","gatewayMac":null,"address":"경기도 양평군 양평읍 양근리","lat":"37.492367400881534","lng":"127.49046343748118"},
                {"insertId":null,"createDateTime":"2024-03-20T08:03:24Z","updateDateTime":"2025-02-05T10:42:13Z","classNo":1238,"gradeName":"2","className":"비알티","fullName":"▶양수역 46017","enable":"Y","classType":0,"apcInfo":null,"mwdDevice":null,"schoolUuid":"2bd96083-4085-4a1d-b40a-86d6e5057836","connectCount":0,"isConnected":"N","option":"{\"arsNo\":\"50008\",\"gatewayMac\":\"g9877e776afe3\"}","gatewayMac":null,"address":"경기도 양평군 양서면 용담리","lat":"37.545546196053415","lng":"127.32884063857267"},
                {"insertId":null,"createDateTime":"2024-07-10T12:14:59Z","updateDateTime":"2025-02-05T10:47:52Z","classNo":1288,"gradeName":"2","className":"비알티","fullName":"▶양동역 46596","enable":"Y","classType":0,"apcInfo":null,"mwdDevice":null,"schoolUuid":"2bd96083-4085-4a1d-b40a-86d6e5057836","connectCount":0,"isConnected":"N","option":"{\"arsNo\":\"46596\",\"gatewayMac\":\"g9877e776b067\"}","gatewayMac":null,"address":"경기도 양평군 양동면 쌍학리","lat":"37.42042216169119","lng":"127.75407360098887"},
                {"insertId":null,"createDateTime":"2024-10-02T04:32:29Z","updateDateTime":"2025-02-11T04:55:05Z","classNo":1311,"gradeName":"2","className":"비알티","fullName":"▶단월중교(보룡2리) 46479","enable":"Y","classType":0,"apcInfo":null,"mwdDevice":null,"schoolUuid":"2bd96083-4085-4a1d-b40a-86d6e5057836","connectCount":0,"isConnected":"N","option":"{\"arsNo\":\"46427\",\"gatewayMac\":\"gb97142001416\",\"memos\":[{\"date\":\"2025/02/11 13:35\",\"memo\":\"02.07 통신장애 발생, 현장사이니지 시간 멈춤 확인<br>조치사항:게이트웨이,공유기 전원 재투입 및 이노에 상태확인 요청 <br>정상작동 확인(최현준대리,박훈과장)\",\"creator\":\"유림\",\"showAll\":true,\"id\":\"yulim00\"},{\"date\":\"2025/02/11 13:53\",\"memo\":\"KT단말기 barcode:FTEQ9183649011250\",\"creator\":\"유림\",\"showAll\":true,\"id\":\"yulim00\"}]}","gatewayMac":null,"address":"경기도 양평군 단월면 보룡리","lat":"37.5421477089433","lng":"127.6728476507813"},
                {"insertId":null,"createDateTime":"2024-10-02T04:32:29Z","updateDateTime":"2025-02-05T10:48:54Z","classNo":1312,"gradeName":"2","className":"비알티","fullName":"▶지평초교(지평4리) 46427","enable":"Y","classType":0,"apcInfo":null,"mwdDevice":null,"schoolUuid":"2bd96083-4085-4a1d-b40a-86d6e5057836","connectCount":0,"isConnected":"N","option":"{\"arsNo\":\"46479\",\"gatewayMac\":\"gb97142001353\",\"memos\":[{\"date\":\"2024/11/02 11:00\",\"memo\":\"모든 디바이스 통신에러로 인도어를 교체 했는데 같은 문제가 재현됨\",\"creator\":\"이노\",\"id\":\"misewatch\",\"showAll\":true},{\"date\":\"2025/01/03 06:15\",\"memo\":\"통신에러가 별도 조치없이 복구됨(좀더 지켜봐야 함)\",\"creator\":\"이노\",\"id\":\"misewatch\",\"showAll\":true},{\"date\":\"2025/01/03 12:55\",\"memo\":\"다시 문제가 발생함\",\"creator\":\"이노\",\"id\":\"misewatch\",\"showAll\":true},{\"date\":\"2025/01/07 14:12\",\"memo\":\"인도어에서 순환기로 가는 RS485 UTP 케이블 교체로 복구됨\",\"creator\":\"유림(최)\",\"id\":\"yulim00\",\"showAll\":true}]}","gatewayMac":null,"address":"경기도 양평군 지평면 지평리","lat":"37.47501407285627","lng":"127.63727046531395"},
                {"insertId":null,"createDateTime":"2024-06-07T08:58:25Z","updateDateTime":"2025-02-05T10:45:12Z","classNo":1264,"gradeName":"3","className":"이지정보통신","fullName":"▶용문역스마트환승쉼터 45928-2(나)","enable":"Y","classType":0,"apcInfo":null,"mwdDevice":null,"schoolUuid":"2bd96083-4085-4a1d-b40a-86d6e5057836","connectCount":0,"isConnected":"N","option":"{\"arsNo\":\"45928\",\"gatewayMac\":\"g9877e776b05f\"}","gatewayMac":null,"address":"경기도 양평군 용문면 다문리","lat":"37.48252880170249","lng":"127.59395821376305"},
                {"insertId":null,"createDateTime":"2024-06-10T06:03:39Z","updateDateTime":"2025-02-05T10:46:55Z","classNo":1267,"gradeName":"3","className":"이지정보통신","fullName":"▶용문국민체육센터스마트환승쉼터 50009","enable":"Y","classType":0,"apcInfo":null,"mwdDevice":null,"schoolUuid":"2bd96083-4085-4a1d-b40a-86d6e5057836","connectCount":0,"isConnected":"N","option":"{\"arsNo\":\"50009\",\"gatewayMac\":\"g9877e776b068\"}","gatewayMac":null,"address":"경기도 양평군 용문면 마룡리","lat":"37.491444244547324","lng":"127.60591582534929"},
                {"insertId":null,"createDateTime":"2023-09-27T09:38:22Z","updateDateTime":"2024-10-23T11:53:57Z","classNo":1095,"gradeName":"기타","className":"실외 45034","fullName":"실외 45034","enable":"Y","classType":1,"apcInfo":null,"mwdDevice":null,"schoolUuid":"2bd96083-4085-4a1d-b40a-86d6e5057836","connectCount":0,"isConnected":"N","option":"{}","gatewayMac":null,"address":null,"lat":null,"lng":null},
                {"insertId":null,"createDateTime":"2024-01-05T12:09:44Z","updateDateTime":"2024-10-23T11:53:57Z","classNo":1163,"gradeName":"기타","className":"실외 46711","fullName":"실외 46711","enable":"Y","classType":1,"apcInfo":null,"mwdDevice":null,"schoolUuid":"2bd96083-4085-4a1d-b40a-86d6e5057836","connectCount":0,"isConnected":"N","option":"{}","gatewayMac":null,"address":null,"lat":null,"lng":null},
                {"insertId":null,"createDateTime":"2024-03-20T08:24:11Z","updateDateTime":"2024-10-23T11:53:57Z","classNo":1239,"gradeName":"기타","className":"실외 46017","fullName":"실외 46017","enable":"Y","classType":1,"apcInfo":null,"mwdDevice":null,"schoolUuid":"2bd96083-4085-4a1d-b40a-86d6e5057836","connectCount":0,"isConnected":"N","option":null,"gatewayMac":null,"address":null,"lat":null,"lng":null},
                {"insertId":null,"createDateTime":"2024-05-01T22:38:47Z","updateDateTime":"2024-10-23T11:53:57Z","classNo":1254,"gradeName":"기타","className":"용문면","fullName":"용문면","enable":"Y","classType":1,"apcInfo":null,"mwdDevice":null,"schoolUuid":"2bd96083-4085-4a1d-b40a-86d6e5057836","connectCount":0,"isConnected":"N","option":null,"gatewayMac":null,"address":null,"lat":null,"lng":null},
                {"insertId":null,"createDateTime":"2024-06-07T08:58:25Z","updateDateTime":"2024-10-23T11:53:57Z","classNo":1265,"gradeName":"기타","className":"실외 46691","fullName":"실외 46691","enable":"Y","classType":1,"apcInfo":null,"mwdDevice":null,"schoolUuid":"2bd96083-4085-4a1d-b40a-86d6e5057836","connectCount":0,"isConnected":"N","option":null,"gatewayMac":null,"address":null,"lat":null,"lng":null},
                {"insertId":null,"createDateTime":"2024-06-07T08:58:25Z","updateDateTime":"2024-10-23T11:53:57Z","classNo":1266,"gradeName":"기타","className":"실외 45928","fullName":"실외 45928","enable":"Y","classType":1,"apcInfo":null,"mwdDevice":null,"schoolUuid":"2bd96083-4085-4a1d-b40a-86d6e5057836","connectCount":0,"isConnected":"N","option":null,"gatewayMac":null,"address":null,"lat":null,"lng":null},
                {"insertId":null,"createDateTime":"2024-06-10T06:03:39Z","updateDateTime":"2024-10-23T11:53:57Z","classNo":1268,"gradeName":"기타","className":"실외 50009","fullName":"실외 50009","enable":"Y","classType":1,"apcInfo":null,"mwdDevice":null,"schoolUuid":"2bd96083-4085-4a1d-b40a-86d6e5057836","connectCount":0,"isConnected":"N","option":null,"gatewayMac":null,"address":null,"lat":null,"lng":null},
                {"insertId":null,"createDateTime":"2024-07-12T00:32:21Z","updateDateTime":"2024-10-23T11:53:57Z","classNo":1289,"gradeName":"기타","className":"실외 46596","fullName":"실외 46596","enable":"Y","classType":1,"apcInfo":null,"mwdDevice":null,"schoolUuid":"2bd96083-4085-4a1d-b40a-86d6e5057836","connectCount":0,"isConnected":"N","option":null,"gatewayMac":null,"address":null,"lat":null,"lng":null},
                {"insertId":null,"createDateTime":"2024-10-02T04:32:29Z","updateDateTime":"2024-10-23T11:53:57Z","classNo":1313,"gradeName":"기타","className":"실외 46427","fullName":"실외 46427","enable":"Y","classType":1,"apcInfo":null,"mwdDevice":null,"schoolUuid":"2bd96083-4085-4a1d-b40a-86d6e5057836","connectCount":0,"isConnected":"N","option":null,"gatewayMac":null,"address":null,"lat":null,"lng":null},
                {"insertId":null,"createDateTime":"2024-10-02T04:32:29Z","updateDateTime":"2024-10-23T11:53:57Z","classNo":1314,"gradeName":"기타","className":"실외 46479","fullName":"실외 46479","enable":"Y","classType":1,"apcInfo":null,"mwdDevice":null,"schoolUuid":"2bd96083-4085-4a1d-b40a-86d6e5057836","connectCount":0,"isConnected":"N","option":null,"gatewayMac":null,"address":null,"lat":null,"lng":null},
                {"insertId":null,"createDateTime":"2024-10-23T11:44:34Z","updateDateTime":"2025-03-17T01:41:05Z","classNo":1327,"gradeName":"기타","className":"양평읍","fullName":"양평읍","enable":"Y","classType":1,"apcInfo":null,"mwdDevice":null,"schoolUuid":"2bd96083-4085-4a1d-b40a-86d6e5057836","connectCount":0,"isConnected":"N","option":"{\"memos\":[{\"date\":\"2025/03/13 09:42\",\"memo\":\"전선 매립공사 진행 중 ㅡ 인터넷 공사 준공 후 연결 가능 ㅡ KT확인 결과 공유기 시리얼과 설치 장소와 주소가 일치하지 않음 ㅡ 이 유리 감독님과 내용 공유\",\"creator\":\"유림\",\"showAll\":true,\"id\":\"yulim00\"}]}","gatewayMac":null,"address":null,"lat":null,"lng":null},
                {"insertId":null,"createDateTime":"2024-10-23T11:47:27Z","updateDateTime":"2024-10-23T11:53:57Z","classNo":1328,"gradeName":"기타","className":"와부읍","fullName":"와부읍","enable":"Y","classType":1,"apcInfo":null,"mwdDevice":null,"schoolUuid":"2bd96083-4085-4a1d-b40a-86d6e5057836","connectCount":0,"isConnected":"N","option":null,"gatewayMac":null,"address":null,"lat":null,"lng":null},
                {"insertId":null,"createDateTime":"2024-10-23T11:53:57Z","updateDateTime":"2024-10-23T11:54:28Z","classNo":1329,"gradeName":"기타","className":"지정면","fullName":"지정면","enable":"Y","classType":1,"apcInfo":null,"mwdDevice":null,"schoolUuid":"2bd96083-4085-4a1d-b40a-86d6e5057836","connectCount":0,"isConnected":"N","option":null,"gatewayMac":null,"address":null,"lat":null,"lng":null}
                ]*/
            
            /*
            "school": {
                "insertId": null,
                "createDateTime": "2019-11-26T21:55:50Z",
                "updateDateTime": "2019-11-26T21:55:50Z",
                "uuid": "a7c13a52-9e50-434c-b0e9-fa3b009163d5",
                "name": "돌마초등학교",
                "type": 3, //3: bus
                "post": "95000",
                "memo":"test<br>12345<br>dkfdslkfsjdflksdfjlks",
                "address1": "경기도 성남시 분당구",
                "address2": " 야탑동 야탑로 96-7",
                "mwgMac": "G00:11:22:33:44:55",
                "mwdsIp": "192.168.111.222",
                "enable": "Y"
            } 
            */         
        }

        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        })
    }
}

async function getDeviceInfo(uuid, wDevice, sDevice, group = null, dateTime = null, limit = 0, skipLoading = null){
    let url = '/iot/device';

    if(skipLoading == true) {
        url = '/iot/device/skiploading';
    }
    
    if (!IS_MOCK) {
        if(dateTime === null){
            // for server
            //alert(moment(new Date()).subtract('minutes', IOT_DEVICE_LOAD_SUBTRACT_MIN/*5*//*1*/));
            //210923 dateTime = moment(new Date()).subtract('minutes', IOT_DEVICE_LOAD_SUBTRACT_MIN/*5*//*1*/).seconds(0).milliseconds(0).toISOString(); // 데이터부터 로딩 ikkim
            dateTime = moment(new Date()).subtract(IOT_DEVICE_LOAD_SUBTRACT_MIN, 'm' /*5*//*1*/).seconds(0).milliseconds(0).toISOString(); // 데이터부터 로딩 ikkim

            //for test
            //dateTime = '2019-11-14 04:38:00';
            //limit = 10;

        }

        //console.log("[getDeviceInfo-1] "+JSON.stringify(wDevice)+"  "+JSON.stringify(sDevice));

        //211008 support 무선 검침기
        let dateTimeR4470 = null;
        if(wDevice.length != 0 && R4470_DEVICE_LOAD_SUBTRACT_MIN != 0) {
            dateTimeR4470 = moment(new Date()).subtract(R4470_DEVICE_LOAD_SUBTRACT_MIN, 'm').seconds(0).milliseconds(0).toISOString(); // 데이터부터 로딩 ikkim
        }

        if(sDevice.length > 0) {
            sDevice = JSON.stringify(sDevice);
        } else {
            sDevice = null;
        }    
        //console.log("[getDeviceInfo-2] "+sDevice);
        return http.get(url, { uuid, group, dateTime, dateTimeR4470, sDevice, limit });
    } else {
        const mockReponse = {
            "m2m:rsp": {
                "m2m:cin": [
                    {
                        "pi": "3gplM3RGQQ",
                        "ri": "Y_9GBjGusG",
                        "ty": 4,
                        "ct": "20191114T043826",
                        "st": 46495,
                        "rn": "4-20191114043826107747175",
                        "lt": "20191114T043826",
                        "et": "20221114T043826",
                        "lbl": [
                            66,
                            25,
                            23,
                            1,
                            1,
                            1049,
                            2719
                        ],
                        "cs": 18,
                        "cr": "Smisewatch",
                        "con": "G11:11:11:11:11:11"
                    },
                    {
                        "pi": "3gplM3RGQQ",
                        "ri": "b6tE7Zn3Jp",
                        "ty": 4,
                        "ct": "20191114T043826",
                        "st": 46495,
                        "rn": "4-20191114043826113878419",
                        "lt": "20191114T043826",
                        "et": "20221114T043826",
                        "lbl": [
                            66,
                            23,
                            26,
                            2,
                            2,
                            430,
                            4914
                        ],
                        "cs": 18,
                        "cr": "Smisewatch",
                        "con": "G22:22:22:22:22:22"
                    },
                    {
                        "pi": "3gplM3RGQQ",
                        "ri": "4f9enrQFiN",
                        "ty": 4,
                        "ct": "20191114T043826",
                        "st": 46495,
                        "rn": "4-20191114043826116169957",
                        "lt": "20191114T043826",
                        "et": "20221114T043826",
                        "lbl": [
                            66,
                            27,
                            20,
                            1,
                            1,
                            494,
                            652
                        ],
                        "cs": 18,
                        "cr": "Smisewatch",
                        "con": "G33:33:33:33:33:33"
                    }
                ]
            }
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        });
    }

}

async function getDeviceInfoSkipLoading(uuid, wDevice, sDevice, group = null, dateTime = null, limit = 0){
    return getDeviceInfo(uuid, wDevice, sDevice, group, dateTime, limit, true);
}

async function getDeviceInfoByDate(param){
    const url = '/iot/deviceByDate';

    if(!IS_MOCK) {
        return http.get(url, param);
    } else {
        const mockResponse = {
                "list": {
                    "m2m:rsp": {
                        "m2m:cin": [
                            {
                                "pi": "1DhUokuQqr-",
                                "ri": "DUKcR8Eoi0W",
                                "ty": "4",
                                "ct": "20250423T101811",
                                "st": "25842",
                                "rn": "4-20250423101811726410764",
                                "lt": "20250423T101811",
                                "et": "20280423T101811",
                                "lbl": [
                                    285541715,
                                    24,
                                    51,
                                    6,
                                    12,
                                    230,
                                    5,
                                    "c20e7b657cb66",
                                    "DATA_G",
                                    "MWC|1|1|0|2|0|0|20|20|200|386281984|16777215|0",
                                    "MWS|s000366313584",
                                    "VET|29",
                                    "TIM|19:18|1|1|1"
                                ],
                                "cs": "13",
                                "cr": "c20e7b657cb66",
                                "con": "c20e7b657cb66"
                            },
                            {
                                "pi": "1DhUokuQqr-",
                                "ri": "rjl7707bg1A",
                                "ty": "4",
                                "ct": "20250423T101705",
                                "st": "25840",
                                "rn": "4-20250423101705547367846",
                                "lt": "20250423T101705",
                                "et": "20280423T101705",
                                "lbl": [
                                    285541715,
                                    24,
                                    52,
                                    6,
                                    11,
                                    230,
                                    7,
                                    "c20e7b657cb66",
                                    "DATA_G",
                                    "MWC|1|1|0|2|0|0|20|20|200|386281984|16777215|0",
                                    "MWS|s000366313584",
                                    "VET|29",
                                    "TIM|19:17|1|1|1"
                                ],
                                "cs": "13",
                                "cr": "c20e7b657cb66",
                                "con": "c20e7b657cb66"
                            },
                            {
                                "pi": "1DhUokuQqr-",
                                "ri": "pKYzTu5t-oE",
                                "ty": "4",
                                "ct": "20250423T101558",
                                "st": "25838",
                                "rn": "4-20250423101558369756193",
                                "lt": "20250423T101558",
                                "et": "20280423T101558",
                                "lbl": [
                                    285541715,
                                    24,
                                    52,
                                    6,
                                    12,
                                    233,
                                    3,
                                    "c20e7b657cb66",
                                    "DATA_G",
                                    "MWC|1|1|0|2|0|0|20|20|200|386281984|16777215|0",
                                    "MWS|s000366313584",
                                    "VET|33",
                                    "TIM|19:15|1|1|1"
                                ],
                                "cs": "13",
                                "cr": "c20e7b657cb66",
                                "con": "c20e7b657cb66"
                            },
                            {
                                "pi": "1DhUokuQqr-",
                                "ri": "WZmXO9n2MH0",
                                "ty": "4",
                                "ct": "20250423T101452",
                                "st": "25836",
                                "rn": "4-20250423101452195645183",
                                "lt": "20250423T101452",
                                "et": "20280423T101452",
                                "lbl": [
                                    285541715,
                                    24,
                                    52,
                                    6,
                                    12,
                                    234,
                                    4,
                                    "c20e7b657cb66",
                                    "DATA_G",
                                    "MWC|1|1|0|2|0|0|20|20|200|386281984|16777215|0",
                                    "MWS|s000366313584",
                                    "VET|35",
                                    "TIM|19:14|1|1|1"
                                ],
                                "cs": "13",
                                "cr": "c20e7b657cb66",
                                "con": "c20e7b657cb66"
                            },
                            {
                                "pi": "1DhUokuQqr-",
                                "ri": "jUI4PAxNdtV",
                                "ty": "4",
                                "ct": "20250423T101346",
                                "st": "25834",
                                "rn": "4-20250423101346016631717",
                                "lt": "20250423T101346",
                                "et": "20280423T101346",
                                "lbl": [
                                    285541715,
                                    24,
                                    52,
                                    6,
                                    11,
                                    234,
                                    6,
                                    "c20e7b657cb66",
                                    "DATA_G",
                                    "MWC|1|1|0|2|0|0|20|20|200|386281984|16777215|0",
                                    "MWS|s000366313584",
                                    "VET|34",
                                    "TIM|19:13|1|1|1"
                                ],
                                "cs": "13",
                                "cr": "c20e7b657cb66",
                                "con": "c20e7b657cb66"
                            },
                            {
                                "pi": "1DhUokuQqr-",
                                "ri": "Vw5pvJEQVRc",
                                "ty": "4",
                                "ct": "20250423T101240",
                                "st": "25832",
                                "rn": "4-20250423101240840578491",
                                "lt": "20250423T101240",
                                "et": "20280423T101240",
                                "lbl": [
                                    285541715,
                                    24,
                                    52,
                                    6,
                                    11,
                                    234,
                                    3,
                                    "c20e7b657cb66",
                                    "DATA_G",
                                    "MWC|1|1|0|2|0|0|20|20|200|386281984|16777215|0",
                                    "MWS|s000366313584",
                                    "VET|35",
                                    "TIM|19:12|1|1|1"
                                ],
                                "cs": "13",
                                "cr": "c20e7b657cb66",
                                "con": "c20e7b657cb66"
                            },
                            {
                                "pi": "1DhUokuQqr-",
                                "ri": "ARFhE7upu-F",
                                "ty": "4",
                                "ct": "20250423T101134",
                                "st": "25830",
                                "rn": "4-20250423101134660175203",
                                "lt": "20250423T101134",
                                "et": "20280423T101134",
                                "lbl": [
                                    285541715,
                                    24,
                                    52,
                                    6,
                                    11,
                                    233,
                                    4,
                                    "c20e7b657cb66",
                                    "DATA_G",
                                    "MWC|1|1|0|2|0|0|20|20|200|386281984|16777215|0",
                                    "MWS|s000366313584",
                                    "VET|34",
                                    "TIM|19:11|1|1|1"
                                ],
                                "cs": "13",
                                "cr": "c20e7b657cb66",
                                "con": "c20e7b657cb66"
                            },
                            {
                                "pi": "1DhUokuQqr-",
                                "ri": "B-TAT-ycQxm",
                                "ty": "4",
                                "ct": "20250423T101028",
                                "st": "25828",
                                "rn": "4-20250423101028486019549",
                                "lt": "20250423T101028",
                                "et": "20280423T101028",
                                "lbl": [
                                    285541715,
                                    24,
                                    52,
                                    6,
                                    12,
                                    235,
                                    3,
                                    "c20e7b657cb66",
                                    "DATA_G",
                                    "MWC|1|1|0|2|0|0|20|20|200|386281984|16777215|0",
                                    "MWS|s000366313584",
                                    "VET|34",
                                    "TIM|19:10|1|1|1"
                                ],
                                "cs": "13",
                                "cr": "c20e7b657cb66",
                                "con": "c20e7b657cb66"
                            },
                            {
                                "pi": "1DhUokuQqr-",
                                "ri": "UzlGchGSnLG",
                                "ty": "4",
                                "ct": "20250423T100921",
                                "st": "25826",
                                "rn": "4-20250423100921310834066",
                                "lt": "20250423T100921",
                                "et": "20280423T100921",
                                "lbl": [
                                    285541715,
                                    24,
                                    52,
                                    6,
                                    11,
                                    235,
                                    3,
                                    "c20e7b657cb66",
                                    "DATA_G",
                                    "MWC|1|1|0|2|0|0|20|20|200|386281984|16777215|0",
                                    "MWS|s000366313584",
                                    "VET|35",
                                    "TIM|19:09|1|1|1"
                                ],
                                "cs": "13",
                                "cr": "c20e7b657cb66",
                                "con": "c20e7b657cb66"
                            },
                            {
                                "pi": "1DhUokuQqr-",
                                "ri": "aYMC72GUwk5",
                                "ty": "4",
                                "ct": "20250423T100815",
                                "st": "25824",
                                "rn": "4-20250423100815087801309",
                                "lt": "20250423T100815",
                                "et": "20280423T100815",
                                "lbl": [
                                    285541715,
                                    24,
                                    52,
                                    6,
                                    12,
                                    235,
                                    2,
                                    "c20e7b657cb66",
                                    "DATA_G",
                                    "MWC|1|1|0|2|0|0|20|20|200|386281984|16777215|0",
                                    "MWS|s000366313584",
                                    "VET|35",
                                    "TIM|19:08|1|1|1"
                                ],
                                "cs": "13",
                                "cr": "c20e7b657cb66",
                                "con": "c20e7b657cb66"
                            },
                            {
                                "pi": "1DhUokuQqr-",
                                "ri": "_GwCUCCzoo4",
                                "ty": "4",
                                "ct": "20250423T100709",
                                "st": "25822",
                                "rn": "4-20250423100709908538971",
                                "lt": "20250423T100709",
                                "et": "20280423T100709",
                                "lbl": [
                                    285541715,
                                    24,
                                    52,
                                    6,
                                    12,
                                    238,
                                    7,
                                    "c20e7b657cb66",
                                    "DATA_G",
                                    "MWC|1|1|0|2|0|0|20|20|200|386281984|16777215|0",
                                    "MWS|s000366313584",
                                    "VET|36",
                                    "TIM|19:07|1|1|1"
                                ],
                                "cs": "13",
                                "cr": "c20e7b657cb66",
                                "con": "c20e7b657cb66"
                            },
                            {
                                "pi": "1DhUokuQqr-",
                                "ri": "ghYTi6z0tau",
                                "ty": "4",
                                "ct": "20250423T100603",
                                "st": "25820",
                                "rn": "4-20250423100603718931946",
                                "lt": "20250423T100603",
                                "et": "20280423T100603",
                                "lbl": [
                                    285541715,
                                    24,
                                    52,
                                    6,
                                    12,
                                    241,
                                    5,
                                    "c20e7b657cb66",
                                    "DATA_G",
                                    "MWC|1|1|0|2|0|0|20|20|200|386281984|16777215|0",
                                    "MWS|s000366313584",
                                    "VET|38",
                                    "TIM|19:05|1|1|1"
                                ],
                                "cs": "13",
                                "cr": "c20e7b657cb66",
                                "con": "c20e7b657cb66"
                            },
                            {
                                "pi": "1DhUokuQqr-",
                                "ri": "8_FGXh7ANNV",
                                "ty": "4",
                                "ct": "20250423T100457",
                                "st": "25818",
                                "rn": "4-20250423100457547783518",
                                "lt": "20250423T100457",
                                "et": "20280423T100457",
                                "lbl": [
                                    285541715,
                                    24,
                                    52,
                                    6,
                                    12,
                                    244,
                                    4,
                                    "c20e7b657cb66",
                                    "DATA_G",
                                    "MWC|1|1|0|2|0|0|20|20|200|386281984|16777215|0",
                                    "MWS|s000366313584",
                                    "VET|41",
                                    "TIM|19:04|1|1|1"
                                ],
                                "cs": "13",
                                "cr": "c20e7b657cb66",
                                "con": "c20e7b657cb66"
                            },
                            {
                                "pi": "1DhUokuQqr-",
                                "ri": "cu7iJwyXLpi",
                                "ty": "4",
                                "ct": "20250423T100350",
                                "st": "25816",
                                "rn": "4-20250423100350364478745",
                                "lt": "20250423T100350",
                                "et": "20280423T100350",
                                "lbl": [
                                    285541715,
                                    24,
                                    52,
                                    6,
                                    12,
                                    244,
                                    6,
                                    "c20e7b657cb66",
                                    "DATA_G",
                                    "MWC|1|1|0|2|0|0|20|20|200|386281984|16777215|0",
                                    "MWS|s000366313584",
                                    "VET|42",
                                    "TIM|19:03|1|1|1"
                                ],
                                "cs": "13",
                                "cr": "c20e7b657cb66",
                                "con": "c20e7b657cb66"
                            },
                            {
                                "pi": "1DhUokuQqr-",
                                "ri": "ArZnv-wie9D",
                                "ty": "4",
                                "ct": "20250423T100244",
                                "st": "25814",
                                "rn": "4-20250423100244189006034",
                                "lt": "20250423T100244",
                                "et": "20280423T100244",
                                "lbl": [
                                    285541715,
                                    24,
                                    52,
                                    6,
                                    12,
                                    243,
                                    7,
                                    "c20e7b657cb66",
                                    "DATA_G",
                                    "MWC|1|1|0|2|0|0|20|20|200|386281984|16777215|0",
                                    "MWS|s000366313584",
                                    "VET|41",
                                    "TIM|19:02|1|1|1"
                                ],
                                "cs": "13",
                                "cr": "c20e7b657cb66",
                                "con": "c20e7b657cb66"
                            },
                            {
                                "pi": "1DhUokuQqr-",
                                "ri": "zOgTvg1qgJt",
                                "ty": "4",
                                "ct": "20250423T100138",
                                "st": "25812",
                                "rn": "4-20250423100138005284080",
                                "lt": "20250423T100138",
                                "et": "20280423T100138",
                                "lbl": [
                                    285541715,
                                    24,
                                    52,
                                    6,
                                    12,
                                    243,
                                    6,
                                    "c20e7b657cb66",
                                    "DATA_G",
                                    "MWC|1|1|0|2|0|0|20|20|200|386281984|16777215|0",
                                    "MWS|s000366313584",
                                    "VET|41",
                                    "TIM|19:01|1|1|1"
                                ],
                                "cs": "13",
                                "cr": "c20e7b657cb66",
                                "con": "c20e7b657cb66"
                            },
                            {
                                "pi": "1DhUokuQqr-",
                                "ri": "nhSS-Uy1nKce",
                                "ty": "4",
                                "ct": "20250423T100032",
                                "st": "25810",
                                "rn": "4-20250423100032842029434",
                                "lt": "20250423T100032",
                                "et": "20280423T100032",
                                "lbl": [
                                    285541715,
                                    24,
                                    52,
                                    6,
                                    12,
                                    242,
                                    6,
                                    "c20e7b657cb66",
                                    "DATA_G",
                                    "MWC|1|1|0|2|0|0|20|20|200|386281984|16777215|0",
                                    "MWS|s000366313584",
                                    "VET|40",
                                    "TIM|19:00|1|1|1"
                                ],
                                "cs": "13",
                                "cr": "c20e7b657cb66",
                                "con": "c20e7b657cb66"
                            },
                            {
                                "pi": "1DhUokuQqr-",
                                "ri": "h68m_jlelXt",
                                "ty": "4",
                                "ct": "20250423T095926",
                                "st": "25808",
                                "rn": "4-20250423095926652149574",
                                "lt": "20250423T095926",
                                "et": "20280423T095926",
                                "lbl": [
                                    285541715,
                                    24,
                                    52,
                                    6,
                                    12,
                                    242,
                                    8,
                                    "c20e7b657cb66",
                                    "DATA_G",
                                    "MWC|1|1|0|2|0|0|20|20|200|386281984|16777215|0",
                                    "MWS|s000366313584",
                                    "VET|40",
                                    "TIM|18:59|1|1|1"
                                ],
                                "cs": "13",
                                "cr": "c20e7b657cb66",
                                "con": "c20e7b657cb66"
                            },
                            {
                                "pi": "1DhUokuQqr-",
                                "ri": "vRf7c4nfGIM",
                                "ty": "4",
                                "ct": "20250423T095820",
                                "st": "25806",
                                "rn": "4-20250423095820473508713",
                                "lt": "20250423T095820",
                                "et": "20280423T095820",
                                "lbl": [
                                    285541715,
                                    24,
                                    52,
                                    6,
                                    11,
                                    241,
                                    10,
                                    "c20e7b657cb66",
                                    "DATA_G",
                                    "MWC|1|1|0|2|0|0|20|20|200|386281984|16777215|0",
                                    "MWS|s000366313584",
                                    "VET|39",
                                    "TIM|18:58|1|1|1"
                                ],
                                "cs": "13",
                                "cr": "c20e7b657cb66",
                                "con": "c20e7b657cb66"
                            },
                            {
                                "pi": "1DhUokuQqr-",
                                "ri": "19WntxvHSEp",
                                "ty": "4",
                                "ct": "20250423T095713",
                                "st": "25804",
                                "rn": "4-20250423095713296317134",
                                "lt": "20250423T095713",
                                "et": "20280423T095713",
                                "lbl": [
                                    285541715,
                                    24,
                                    52,
                                    6,
                                    11,
                                    241,
                                    7,
                                    "c20e7b657cb66",
                                    "DATA_G",
                                    "MWC|1|1|0|2|0|0|20|20|200|386281984|16777215|0",
                                    "MWS|s000366313584",
                                    "VET|39",
                                    "TIM|18:57|1|1|1"
                                ],
                                "cs": "13",
                                "cr": "c20e7b657cb66",
                                "con": "c20e7b657cb66"
                            },
                            {
                                "pi": "1DhUokuQqr-",
                                "ri": "ZO9fGpOAzg1",
                                "ty": "4",
                                "ct": "20250423T095607",
                                "st": "25802",
                                "rn": "4-20250423095607114080265",
                                "lt": "20250423T095607",
                                "et": "20280423T095607",
                                "lbl": [
                                    285541715,
                                    24,
                                    52,
                                    6,
                                    11,
                                    244,
                                    10,
                                    "c20e7b657cb66",
                                    "DATA_G",
                                    "MWC|1|1|0|2|0|0|20|20|200|386281984|16777215|0",
                                    "MWS|s000366313584",
                                    "VET|40",
                                    "TIM|18:56|1|1|1"
                                ],
                                "cs": "13",
                                "cr": "c20e7b657cb66",
                                "con": "c20e7b657cb66"
                            },
                            {
                                "pi": "1DhUokuQqr-",
                                "ri": "CJYHRn9rOGu",
                                "ty": "4",
                                "ct": "20250423T095501",
                                "st": "25800",
                                "rn": "4-20250423095501984613397",
                                "lt": "20250423T095501",
                                "et": "20280423T095501",
                                "lbl": [
                                    285541715,
                                    24,
                                    52,
                                    6,
                                    11,
                                    247,
                                    12,
                                    "c20e7b657cb66",
                                    "DATA_G",
                                    "MWC|1|1|0|2|0|0|20|20|200|386281984|16777215|0",
                                    "MWS|s000366313584",
                                    "VET|40",
                                    "TIM|18:54|1|1|1"
                                ],
                                "cs": "13",
                                "cr": "c20e7b657cb66",
                                "con": "c20e7b657cb66"
                            }
                        ]
                    }
            }
        }
        return new Promise((resolve) => {
        setTimeout(() => {
            resolve(mockResponse);
        }, 100);
        })
    }
}
  
async function getDeviceInfoLatest(uuid, device){
    const url = '/iot/device/latest';
    if (!IS_MOCK) {
        //console.log("[getDeviceInfoLatest] uuid="+uuid+" devices="+JSON.stringify(device));

        /*
        if(device.length > 0) {
            device = JSON.stringify(device);
        } else {
            device = null;
        } 
        */

        //console.log("[getDeviceInfo-2] "+sDevice);
        return http.get(url, { uuid, device });
    } else {
        const mockReponse = {
            "m2m:rsp": {
                "m2m:cin": [
                    {
                        "pi": "3gplM3RGQQ",
                        "ri": "Y_9GBjGusG",
                        "ty": 4,
                        "ct": "20191114T043826",
                        "st": 46495,
                        "rn": "4-20191114043826107747175",
                        "lt": "20191114T043826",
                        "et": "20221114T043826",
                        "lbl": [
                            66,
                            25,
                            23,
                            1,
                            1,
                            1049,
                            2719
                        ],
                        "cs": 18,
                        "cr": "Smisewatch",
                        "con": "G11:11:11:11:11:11"
                    },
                    {
                        "pi": "3gplM3RGQQ",
                        "ri": "b6tE7Zn3Jp",
                        "ty": 4,
                        "ct": "20191114T043826",
                        "st": 46495,
                        "rn": "4-20191114043826113878419",
                        "lt": "20191114T043826",
                        "et": "20221114T043826",
                        "lbl": [
                            66,
                            23,
                            26,
                            2,
                            2,
                            430,
                            4914
                        ],
                        "cs": 18,
                        "cr": "Smisewatch",
                        "con": "G22:22:22:22:22:22"
                    },
                    {
                        "pi": "3gplM3RGQQ",
                        "ri": "4f9enrQFiN",
                        "ty": 4,
                        "ct": "20191114T043826",
                        "st": 46495,
                        "rn": "4-20191114043826116169957",
                        "lt": "20191114T043826",
                        "et": "20221114T043826",
                        "lbl": [
                            66,
                            27,
                            20,
                            1,
                            1,
                            494,
                            652
                        ],
                        "cs": 18,
                        "cr": "Smisewatch",
                        "con": "G33:33:33:33:33:33"
                    }
                ]
            }
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        });
    }

}

async function getDashboardInfo(uuid, wDevice, sDevice){
    const url = '/iot/dashboard';
    /*
    if (!IS_MOCK) {
        if(dateTime === null){
            // for server
            dateTime = moment(new Date()).toISOString();

            //for test
            //dateTime = '2019-11-14 04:38:00';
            //limit = 10;
        }
    }
    */
    // for server
    // 1분 전 데이터 조회
    // 최초 데이터는 Sync가 맞지 않을 수 있으므로, 2분 전으로 전송
    
    // mock data 분기 추가
    if(!IS_MOCK) {
        //alert(moment(new Date()));
        //alert("iot2="+IOT_DASHBOARD_LOAD_SUBTRACT_MIN);
        //210923 let dateTime = moment(new Date()).subtract('m', IOT_DASHBOARD_LOAD_SUBTRACT_MIN/*6*//*2*/).seconds(0).milliseconds(0).toISOString(); // 데이터부터 로딩 ikkim
        let dateTime = moment(new Date()).subtract(IOT_DASHBOARD_LOAD_SUBTRACT_MIN, 'm' /*6*//*2*/).seconds(0).milliseconds(0).toISOString(); // 데이터부터 로딩 ikkim
        
        //console.log("[getDashboardInfo-1] "+JSON.stringify(wDevice)+"  "+JSON.stringify(sDevice));

        //211008 support 무선 검침기
        let dateTimeR4470 = null;
        if(wDevice.length != 0 && R4470_DEVICE_LOAD_SUBTRACT_MIN != 0) {
            dateTimeR4470 = moment(new Date()).subtract(R4470_DEVICE_LOAD_SUBTRACT_MIN, 'm' /*6*//*2*/).seconds(0).milliseconds(0).toISOString(); // 데이터부터 로딩 ikkim
        }
        //console.log("[getDashboardInfo-1] "+JSON.stringify(sDevice));
        if(sDevice.length > 0) {
            sDevice = JSON.stringify(sDevice); //sDevice.toString();//
        } else {
            sDevice = null;
        }
        //console.log("[getDashboardInfo-2] "+JSON.stringify(sDevice));

        return http.get(url, { uuid, dateTime, dateTimeR4470, sDevice });
    } else {
        const mockReponse = {
            apc: null,
            device: null,
            station: null
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        });
    }

    //let dateTime = moment('20191114T000000').subtract('m', 1).toISOString();
}

async function getSchoolList(searchValue = null, enable = null, isExistGateway = null, page = null){
    let url = `${PREFIX}/list`
    if (!IS_MOCK) {
        let ver = new Date().getTime();
        return http.get(url, { ver, searchValue, enable, isExistGateway,...page });
    } else {
        const mockReponse = {
            "totalcount":98,
            "list":[
                {"insertId":null,"createDateTime":"2020-01-19T22:20:38Z","updateDateTime":"2020-01-20T06:58:58Z","schoolNo":4,"uuid":"c8a10db7-bd49-4ad2-bda9-e8d2623b99b8","name":"용인초등학교","type":0,"post":"17044","address1":"경기 용인시 처인구 금학로367번길 14","address2":"용인초등학교","mwdsIp":null,"enable":"Y","installationNum":"942062","telNo":"123-12333-123","bizNo":"1234","rank":0,"deviceCount":0,"schoolClass":null},
                {"insertId":null,"createDateTime":"2019-11-27T14:55:52Z","updateDateTime":"2019-11-27T14:55:50Z","schoolNo":3,"uuid":"a7c13a52-9e50-434c-b0e9-fa3b009163d8","name":"이세돌돌초등학교","type":0,"post":"95000","address1":"경기도 성남시 분당구","address2":" 야탑동 야탑로 96-7","mwdsIp":"192.168.111.222","enable":"Y","installationNum":null,"telNo":null,"bizNo":null,"rank":0,"deviceCount":0,"schoolClass":null},
                {"insertId":null,"createDateTime":"2019-11-27T14:55:51Z","updateDateTime":"2019-11-27T14:55:50Z","schoolNo":2,"uuid":"a7c13a52-9e50-434c-b0e9-fa3b009163d7","name":"이세돌마초등학교","type":0,"post":"95000","address1":"경기도 성남시 분당구","address2":" 야탑동 야탑로 96-7","mwdsIp":"192.168.111.222","enable":"Y","installationNum":null,"telNo":null,"bizNo":null,"rank":0,"deviceCount":0,"schoolClass":null},
                {"insertId":null,"createDateTime":"2019-11-27T14:55:50Z","updateDateTime":"2020-01-17T03:54:51Z","schoolNo":1,"uuid":"a7c13a52-9e50-434c-b0e9-fa3b009163d6","name":"돌마초등학교","type":0,"post":"13517","address1":"경기 성남시 분당구 야탑로 96-7","address2":"돌마초등학교","mwdsIp":"192.168.111.222","enable":"Y","installationNum":"979001","telNo":"031-1234-1234","bizNo":"100","rank":0,"deviceCount":5,"schoolClass":null},
                
                {"insertId":null,"createDateTime":"2019-11-27T14:55:51Z","updateDateTime":"2019-11-27T14:55:50Z","schoolNo":2,"uuid":"a7c13a52-9e50-434c-b0e9-fa3b009163d7","name":"A중학교","type":0,"post":"95000","address1":"경기도 성남시 분당구","address2":" 야탑동 야탑로 96-7","mwdsIp":"192.168.111.222","enable":"Y","installationNum":null,"telNo":null,"bizNo":null,"rank":0,"deviceCount":0,"schoolClass":null},
                {"insertId":null,"createDateTime":"2019-11-27T14:55:51Z","updateDateTime":"2019-11-27T14:55:50Z","schoolNo":2,"uuid":"a7c13a52-9e50-434c-b0e9-fa3b009163d7","name":"b초등학교","type":0,"post":"95000","address1":"경기도 성남시 분당구","address2":" 야탑동 야탑로 96-7","mwdsIp":"192.168.111.222","enable":"Y","installationNum":null,"telNo":null,"bizNo":null,"rank":0,"deviceCount":0,"schoolClass":null},
                {"insertId":null,"createDateTime":"2019-11-27T14:55:51Z","updateDateTime":"2019-11-27T14:55:50Z","schoolNo":2,"uuid":"a7c13a52-9e50-434c-b0e9-fa3b009163d7","name":"♥초등학교","type":0,"post":"95000","address1":"경기도 성남시 분당구","address2":" 야탑동 야탑로 96-7","mwdsIp":"192.168.111.222","enable":"Y","installationNum":null,"telNo":null,"bizNo":null,"rank":0,"deviceCount":0,"schoolClass":null},
                {"insertId":null,"createDateTime":"2019-11-27T14:55:51Z","updateDateTime":"2019-11-27T14:55:50Z","schoolNo":2,"uuid":"a7c13a52-9e50-434c-b0e9-fa3b009163d7","name":"●초등학교","type":0,"post":"95000","address1":"경기도 성남시 분당구","address2":" 야탑동 야탑로 96-7","mwdsIp":"192.168.111.222","enable":"Y","installationNum":null,"telNo":null,"bizNo":null,"rank":0,"deviceCount":0,"schoolClass":null},
                {"insertId":null,"createDateTime":"2019-11-27T14:55:51Z","updateDateTime":"2019-11-27T14:55:50Z","schoolNo":2,"uuid":"a7c13a52-9e50-434c-b0e9-fa3b009163d7","name":"상초등학교","type":0,"post":"95000","address1":"경기도 성남시 분당구","address2":" 야탑동 야탑로 96-7","mwdsIp":"192.168.111.222","enable":"Y","installationNum":null,"telNo":null,"bizNo":null,"rank":0,"deviceCount":0,"schoolClass":null},
                {"insertId":null,"createDateTime":"2019-11-27T14:55:51Z","updateDateTime":"2019-11-27T14:55:50Z","schoolNo":2,"uuid":"a7c13a52-9e50-434c-b0e9-fa3b009163d7","name":"쌍초등학교","type":0,"post":"95000","address1":"경기도 성남시 분당구","address2":" 야탑동 야탑로 96-7","mwdsIp":"192.168.111.222","enable":"Y","installationNum":null,"telNo":null,"bizNo":null,"rank":0,"deviceCount":0,"schoolClass":null},
                {"insertId":null,"createDateTime":"2019-11-27T14:55:51Z","updateDateTime":"2019-11-27T14:55:50Z","schoolNo":2,"uuid":"a7c13a52-9e50-434c-b0e9-fa3b009163d7","name":"빵초등학교","type":0,"post":"95000","address1":"경기도 성남시 분당구","address2":" 야탑동 야탑로 96-7","mwdsIp":"192.168.111.222","enable":"Y","installationNum":null,"telNo":null,"bizNo":null,"rank":0,"deviceCount":0,"schoolClass":null},
            ]
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        });
    }

}

async function createSchool(param){
    let url = `${PREFIX}`
    return http.post(url, param, {headers : {
        'Content-type' : 'multipart/form-data'
      }});
}
async function updateSchool(param){
    let url = `${PREFIX}/update`
    //return http.put(url, param);
    return http.post(url, param, {headers : {
        'Content-type' : 'multipart/form-data'
      }});
}
async function updateSchoolClass(param){
    if (!IS_MOCK) {
        let url = `${PREFIX}/updateclass`
        return http.put(url, param);
    } else {
        const mockReponse = { 
            
        }

        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        })
    }
}

async function updateSchoolByManager(param){
    let url = `${PREFIX}/updatebymanager`
    //return http.put(url, param);
    return http.post(url, param, {headers : {
        'Content-type' : 'multipart/form-data'
      }});
}

async function updateSchoolParam(param){
    let url = `${PREFIX}/updateParam`
    return http.put(url, param);
}

async function deleteSchool(uuid){
    //let url = `${PREFIX}`
    //return http.delete(url, uuid);
    
    //220428
    let url = `${PREFIX}/${uuid}`
    return http.delete(url);
}

export default {
    getSchool,
    getSchoolInfoByNo,
    getDeviceInfo,
    getDeviceInfoSkipLoading,
    getDeviceInfoByDate,
    getDeviceInfoLatest,
    getDashboardInfo,
    getSchoolList,
    createSchool,
    updateSchool,
    updateSchoolClass,
    updateSchoolByManager,
    updateSchoolParam,
    deleteSchool
};
